import React from 'react';
import './MediaSourceInputRow.css';

const PLATFORM_OPTIONS = ['youtube', 'instagram', 'tiktok', 'twitter'];
const TYPE_OPTIONS = ['short', 'full', 'audio'];

const MediaSourceInputRow = ({
  data,
  index,
  onChange,
  onRemove,
  onSetPrimary,
  isPrimary,
  canRemove,
  errors
}) => {
  const rowStyle = {
    border: isPrimary ? '2px solid #0f766e' : '1px solid #d0d5dd',
    borderRadius: 10,
    padding: 12,
    marginBottom: 12,
    background: isPrimary ? '#ecfdf3' : '#ffffff'
  };

  const invalidStyle = {
    borderColor: '#d92d20',
    boxShadow: '0 0 0 1px #d92d20'
  };

  return (
    <div style={rowStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <strong>Source {index + 1}</strong>
        {isPrimary && (
          <span style={{ color: '#065f46', fontWeight: 700, fontSize: 12 }}>Primary Source</span>
        )}
      </div>

      <div className="media-source-grid-row">
        <div className="form-group" style={{ margin: 0 }}>
          <label>Platform</label>
          <select
            value={data.platform}
            onChange={(e) => onChange(index, 'platform', e.target.value)}
            style={errors?.platform ? invalidStyle : undefined}
          >
            {PLATFORM_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
          {errors?.platform && <small style={{ color: '#b42318' }}>{errors.platform}</small>}
        </div>

        <div className="form-group" style={{ margin: 0 }}>
          <label>URL</label>
          <input
            type="url"
            value={data.url}
            onChange={(e) => onChange(index, 'url', e.target.value)}
            placeholder="https://..."
            style={errors?.url ? invalidStyle : undefined}
          />
          {errors?.url && <small style={{ color: '#b42318' }}>{errors.url}</small>}
        </div>

        <div className="form-group" style={{ margin: 0 }}>
          <label>Type</label>
          <select
            value={data.type}
            onChange={(e) => onChange(index, 'type', e.target.value)}
          >
            {TYPE_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 10, fontSize: 13 }}>
          <input
            type="radio"
            name="primarySource"
            checked={isPrimary}
            onChange={() => onSetPrimary(index)}
          />
          Set as Primary
        </label>

        <button
          type="button"
          className="action-button"
          onClick={() => onRemove(index)}
          disabled={!canRemove}
          style={{ marginBottom: 8, width: 'auto', padding: '10px 14px', opacity: canRemove ? 1 : 0.5 }}
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default MediaSourceInputRow;
